export default "__VITE_ASSET__0c6a0a91__"